<script lang="ts">import Clarity from "./includes/clarity.svelte";
import Google from "./includes/google.svelte";
import Optimove from "./navigation/optimove.svelte";
</script>

<Optimove />
<Google />
<Clarity />
